module.exports = __webpack_public_path__ + "static/hr_ad_3-0e8b4f0ecbc356015ca0e278bafabb41.png";